const BackBtnDark = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.75" y="0.75" width="46.5" height="46.5" rx="23.25" stroke="#A1A1A1" strokeWidth="1.5"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M22.5303 17.4697C22.8232 17.7626 22.8232 18.2374 22.5303 18.5303L17.8107 23.25H32C32.4142 23.25 32.75 23.5858 32.75 24C32.75 24.4142 32.4142 24.75 32 24.75H17.8107L22.5303 29.4697C22.8232 29.7626 22.8232 30.2374 22.5303 30.5303C22.2374 30.8232 21.7626 30.8232 21.4697 30.5303L15.4697 24.5303C15.1768 24.2374 15.1768 23.7626 15.4697 23.4697L21.4697 17.4697C21.7626 17.1768 22.2374 17.1768 22.5303 17.4697Z" fill="#0F0F0F"/>
        </svg>
    )
}

export default BackBtnDark